export default __webpack_public_path__ + "static/media/logo-rimac.93383d6f.svg";